// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3j8p8","inputDescription":"styles_inputDescription__3ap26"};